import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AppEventDispatcher } from '../../utils/AppEventDispatcher';
import { RenameYourAccountEventType } from './rename-your-account.event.type';
import { RenameAccount } from './model/rename-account';
import { TweenMax, Quint } from 'gsap';

@Component({
	selector: 'app-rename-your-account',
	templateUrl: './rename-your-account.component.html',
	styleUrls: ['./rename-your-account.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class RenameYourAccountComponent implements OnInit, OnDestroy {

	public flow: Array<string> = [
		RenameYourAccountEventType.SEND.RENAME_ACCOUNT_SEND,
		RenameYourAccountEventType.SEND.RENAME_ACCOUNT_CONFIRM
	];
	public form: FormGroup;
	public submited: boolean;
	public activeBackButton = false;
	public flowIndex = 0;
	public showStepButtons = true;
	public subtitle = [
		'A seguir você pode substituir o nome atual da sua conta.',
		'Conta renomeada!'
	];
	public renameAccountData: RenameAccount  = new RenameAccount();

	constructor() { }

	ngOnInit() {
		TweenMax.delayedCall(.3, () => {
			this.show();
		});
		/**
		 * Faz a troca de botões ao chegar no final dos passos.
		 */
		AppEventDispatcher.listen(RenameYourAccountEventType.BUTTONS, data => {

			TweenMax.to('.buttons', .8, {bottom: '-100%', ease: Quint.easeOut});
			TweenMax.delayedCall(.6, () => {
				this.activeBackButton = true;

				TweenMax.delayedCall(.2, () => {
					TweenMax.to('.buttons', .8, {bottom: 0, ease: Quint.easeOut});
				});
			});

		});

		AppEventDispatcher.listen(RenameYourAccountEventType.ERROR, (data): any => {

			this.flowIndex = this.flow.findIndex((item, index, array) => {
				if (item === data.step) {
					return true;
				} else {
					return false;
				}
			});

		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(RenameYourAccountEventType.BUTTONS);
		AppEventDispatcher.removeListener(RenameYourAccountEventType.ERROR);
	}

	show() {
		AppEventDispatcher.dispatch(RenameYourAccountEventType.STEPS.RENAME_ACCOUNT_RESET, { show: true });
	}

	setForm(form: FormGroup) {
		this.form = form;
	}

	sendForm(event) {
		this.submited = true;

		if (this.form.valid) {

			AppEventDispatcher.dispatch(this.flow[this.flowIndex], null);
			this.flowIndex++;
		}

	}

	public onShowStepButtons(value: boolean) {
		this.showStepButtons = value;
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/rename-your-account/rename-your-account.component.ts